export default class PlacementType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}
